<template>
  <SearchSuggestionSelect
    :model-value="modelValue"
    :options="currencyOptions"
    :label="label"
    :placeholder="placeholder"
    :hint="hint"
    :disabled="disabled"
    :clearable="clearable"
    empty-text="No matching currency"
    @change="$emit('change', $event)"
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script>
import HSSearchSuggestionSelect from "@/components/common/HSSearchSuggestionSelect.vue";
import allCurrencies from "@/utils/currencies";

const currencyCountries = {
  AED: ["United Arab Emirates"],
  AUD: ["Australia", "Kiribati", "Nauru", "Tuvalu"],
  BIF: ["Burundi"],
  CAD: ["Canada"],
  CDF: ["Democratic Republic of the Congo", "DR Congo", "Congo"],
  CHF: ["Switzerland", "Liechtenstein"],
  CNY: ["China"],
  EUR: ["European Union", "France", "Germany", "Italy", "Spain", "Netherlands", "Belgium"],
  GBP: ["United Kingdom", "England", "Scotland", "Wales", "Northern Ireland"],
  GHS: ["Ghana"],
  INR: ["India"],
  JPY: ["Japan"],
  KES: ["Kenya"],
  NGN: ["Nigeria"],
  RWF: ["Rwanda"],
  TZS: ["Tanzania"],
  UGX: ["Uganda"],
  USD: ["United States", "Ecuador", "El Salvador", "Panama", "Zimbabwe"],
  XAF: ["Cameroon", "Central African Republic", "Chad", "Republic of the Congo", "Equatorial Guinea", "Gabon"],
  XCD: ["Antigua and Barbuda", "Dominica", "Grenada", "Saint Lucia", "Saint Vincent and the Grenadines"],
  XOF: ["Benin", "Burkina Faso", "Ivory Coast", "Mali", "Niger", "Senegal", "Togo"],
  ZAR: ["South Africa", "Lesotho", "Namibia", "Eswatini"],
  ZMW: ["Zambia"],
};

export default {
  name: "HSCurrencySelect",
  components: { SearchSuggestionSelect: HSSearchSuggestionSelect },
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "Search currency" },
    hint: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
  },
  emits: ["update:modelValue", "change"],
  computed: {
    currencyOptions() {
      return allCurrencies.map((currency) => {
        const countries = currency.countries || currencyCountries[currency.code] || [];
        return {
          value: currency.code,
          label: `${currency.code} - ${currency.name}`,
          description: countries.join(", "),
          keywords: [currency.code, currency.name, ...countries],
        };
      });
    },
  },
};
</script>
